﻿class Recaptcha {
  constructor() {
  }
  init() {
    window.captchaContainer = null;

    window.loadCaptcha = function () {
      
      const containers = document.querySelectorAll('.g-recaptcha') ? document.querySelectorAll('.g-recaptcha') : null;
      if (containers) {
        containers.forEach(container => {
  
          captchaContainer = grecaptcha.render(container, {
            'sitekey': container.getAttribute('data-sitekey'),
            'callback': function (response) {
            }
          });
        })
      }
    };
  }
  reInit() {
    const containers = document.querySelectorAll('.g-recaptcha') ? document.querySelectorAll('.g-recaptcha') : null;
    if (containers) {
      containers.forEach(container => {

        captchaContainer = grecaptcha.render(container, {
          'sitekey': container.getAttribute('data-sitekey'),
          'callback': function (response) {
          }
        });
      })
    }
  }
}


export default new Recaptcha();